const root = (window as any)._env_?.BASE_URL
const moduleRoutes = {
    root,
    mainRoute:"ui/main",
    authentication:"ui/authentication",
    dashboard:"dashboard",
    patientCare:"patient-care",
    insurance:"insurance",
    reports:"reports",
    masters:"masters",
    settings:"settings",
    angular:"angular",
    help:"help",
}

export default moduleRoutes